import React from "react";
import Vector from "../../../../../Assets/Images/Empty-state-2.svg";

const ChatlistEmptyState = (props) => {
  return (
    <div className="chat-list-empty-state">
      <img alt="" src={Vector}></img>
      <p>{props.Text}</p>
    </div>
  );
};

export default ChatlistEmptyState;
